import { GlobalContext } from "@/Context/GlobalProvider";
import { useContext, useState } from "react";
import { toast } from "react-toastify";

function useDownload() {
    const { csrf_token: token } = useContext(GlobalContext);
    const [isDownloading, setIsDownloading] = useState();
    const [toastId, setToastId] = useState();

    async function download(files) {
        const toastId = toast.loading("Preparing download...", {
            position: "bottom-right",
        });
        setToastId(toastId);
        setIsDownloading(true);
        if (Array.isArray(files)) {
            for (const file of files) {
                await downloadFile(file);
            }
        } else if (typeof files === "object") {
            await downloadFile(files);
        }

        toast.update(toastId, {
            render: "Downloaded successfully!",
            type: "success",
            isLoading: false,
            autoClose: 3000,
        });
        setToastId(null);
        setIsDownloading(false);
    }

    async function downloadFile({ url, title }) {
        String.prototype.capitalize = function () {
            return this.split(" ")
                .map(
                    (word) =>
                        word.charAt(0).toUpperCase() +
                        word.slice(1).toLowerCase()
                )
                .join(" ");
        };

        try {
            // Use fetch with CSRF token from Inertia page props
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": token,
                    Accept: "application/json",
                },
            });

            if (!response.ok) {
                throw new Error("Failed to generate download URL");
            }

            const data = await response.json();

            if (!data.url) {
                throw new Error("No download URL received");
            }

            // Use the signed URL to download the PDF
            const pdfResponse = await fetch(data.url);
            if (pdfResponse.ok) {
                const blob = await pdfResponse.blob();
                const downloadUrl = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = downloadUrl;
                a.download = `${title.capitalize()}.pdf`;
                document.body.appendChild(a);
                a.click();
                a.remove();
            } else {
                throw new Error("Download failed");
            }
        } catch (error) {
            toast.update(toastId, {
                render:
                    error.message || "Error occurred while downloading PDF.",
                type: "error",
                isLoading: false,
                autoClose: 5000,
            });
        }
    }

    return { download, isDownloading };
}

export default useDownload;
